import { useState } from "react";

export interface NavigationAudio {
  checkmark: HTMLAudioElement;
  confirmNumber: HTMLAudioElement;
  select: HTMLAudioElement;
  menu: HTMLAudioElement;
}

export default function useNavigationAudio(): NavigationAudio {
  const [checkmark] = useState(new Audio("/audio/navigation/checkmark.wav"));
  const [confirmNumber] = useState(
    new Audio("/audio/navigation/confirmNumber.wav")
  );
  const [select] = useState(new Audio("/audio/navigation/select.wav"));
  const [menu] = useState(new Audio("/audio/navigation/menu.wav"));

  return {
    checkmark,
    confirmNumber,
    select,
    menu,
  };
}
